import { selectCoopProjectType } from "../balancingSelectors/selectBalancingCoopProjects";
import { selectResourceInfo } from "../balancingSelectors/selectBalancingResources";
export var selectCoopProjectInfo = function (state) {
    return state.coopInfo.project;
};
export var selectRunningCoopProjectResourceCollectionProgress = function (state, resourceId) {
    var resourceCollectionProgress;
    var activeProject = selectCoopProjectInfo(state);
    if (activeProject && activeProject.task) {
        var collectionTask = activeProject.task.find(function (task) { return task.itemId === resourceId; });
        if (collectionTask) {
            resourceCollectionProgress = collectionTask.amount;
        }
    }
    return resourceCollectionProgress;
};
export var selectCoopBuff = function (state, context, target) {
    return state.coopInfo.buffs.filter(function (buffElement) { return buffElement.target === target && buffElement.context === context; });
};
export var selectRunningCoopProjectRequiredResourceAmount = function (state, resourceId) {
    var requiredResourceType = selectRunningCoopProjectRequiredResourceType(state, resourceId);
    return requiredResourceType ? requiredResourceType.amount : undefined;
};
export var selectRunningCoopProjectRequiredResourceType = function (state, resourceId) {
    var requiredResourceType;
    var activeProject = selectCoopProjectInfo(state);
    if (activeProject) {
        var activeDifficultyLevel = selectProjectDifficultyLevelType(state, activeProject.typeId, activeProject.difficulty);
        if (activeDifficultyLevel && activeDifficultyLevel.requiredRes) {
            requiredResourceType = activeDifficultyLevel.requiredRes.find(function (resource) { return resource.resourceId === resourceId; });
        }
    }
    return requiredResourceType;
};
export var selectProjectDifficultyLevelType = function (state, typeId, level) {
    var projectDifficultyLevelType;
    if (typeId && level) {
        var project = selectCoopProjectType(typeId);
        if (project) {
            projectDifficultyLevelType = project.difficultyLevel.find(function (difficultyLevel) { return difficultyLevel.level === level; });
        }
    }
    return projectDifficultyLevelType;
};
export var selectIsResourceBeingCollected = function (state, resourceId) {
    var resourceCollectionProgress = selectRunningCoopProjectResourceCollectionProgress(state, resourceId);
    var requiredResourceAmount = selectRunningCoopProjectRequiredResourceAmount(state, resourceId);
    return (resourceCollectionProgress != undefined &&
        requiredResourceAmount != undefined &&
        resourceCollectionProgress < requiredResourceAmount);
};
export var selectActiveCoopProjectResources = function (state) {
    var activeProject = selectCoopProjectInfo(state);
    return activeProject && activeProject.task
        ? activeProject.task
            .filter(function (task) { return selectIsResourceBeingCollected(state, task.itemId); })
            .map(function (task) { return selectResourceInfo(task.itemId); })
        : [];
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectCoopProjectInfo.ts
// module id = 198
// module chunks = 3